<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{ $t('documentation.titles.signatures.title') }}
    </h1>
    <h2 class="primary--text">
      {{ $t('documentation.texts.signatures.signatureAbandon.title') }}
    </h2>
    <p>
      {{ $t('documentation.texts.signatures.signatureAbandon.paragraph1') }}
    </p>
    <v-img
      style="width: 100%; max-width: 600px"
      contain
      :src="picJointDetail"
    />
    <v-img style="width: 100%; max-width: 600px" contain :src="picAbandon" />
    <v-img
      style="width: 100%; max-width: 600px"
      contain
      :src="picAbandonHistory"
    />
  </v-col>
</template>

<script>
export default {
  computed: {
    picAbandon() {
      return require('@/assets/documentation/signatures/' +
        this.$t('documentation.texts.signatures.signatureAbandon.picAbandon') +
        '.png')
    },
    picJointDetail() {
      return require('@/assets/documentation/signatures/' +
        this.$t(
          'documentation.texts.signatures.signatureAbandon.picJointDetail'
        ) +
        '.png')
    },
    picAbandonHistory() {
      return require('@/assets/documentation/signatures/' +
        this.$t(
          'documentation.texts.signatures.signatureAbandon.picAbandonHistory'
        ) +
        '.png')
    },
  },
  methods: {},
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
